import { Component, OnInit } from '@angular/core';
import { environment } from "../../../environments/environment";


@Component({
  selector: 'app-airport-sidebar',
  templateUrl: './airport-sidebar.component.html',
  styleUrls: ['./airport-sidebar.component.css']
})
export class AirportSidebarComponent implements OnInit {

  userID: any;
  roleID: any;
  username: any;
  isAirport = false;
  env: any;

  constructor() { }

  ngOnInit() {
    this.env = environment;

    this.username = localStorage.getItem("username");
    this.roleID = localStorage.getItem("role_id");
    this.userID = localStorage.getItem("id");
    if (this.roleID == 9) {
      this.isAirport = true;
    }
  }
  Mobile_sidebar_menu_btn(){
    $(".mobile-menu-asidebar").fadeToggle(500);
  }

}
